<template lang="pug">
  v-text-field(
    v-model="model"
    v-bind="$attrs"
    :rules="[_value => isValidURL(_value) || `Le lien est invalide.`, ...$attrs.rules].filter(Boolean)")
</template>

<script>
import { computed } from '@vue/composition-api'

const isValidURL = str => {
  if (!str) {
    return true
  }
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str)
}

export default {
  props: {
    value: String
  },

  setup (props, context) {
    const model = computed({
      get: () => props.value,
      set: value => {
        context.emit(`input`, value)
      }
    })

    return {
      model,
      isValidURL
    }
  }
}
</script>
